import React, { useEffect, useState } from 'react';
import ShipDateDropdown from '../../sharedComponents/ShipDateDropdown';
import OrderSummaryTable from '../../sharedComponents/OrderSummaryTable';
import useCollectMoney from './useCollectMoney';
import { AgGridReact } from 'ag-grid-react';
import { formatAmount } from '../../utils/formatAmount';

const CollectMoneyOldNotPaid = () => {
  const [activeGroupIndex, setActiveGroupIndex] = useState(null);
  const [rowData, setRowData] = useState([]); // Initialize as an empty array
  
  const { orders, getOldPersonNotPaidData, getOldPersonNotPaid } = useCollectMoney();
  
  const gridOptions = {
    enableCellTextSelection: true, // Allow text selection
    onCellClicked: (params) => {
      getOldPersonNotPaidData(params.data.id); // Send customerId when clicked
    }
  };

  const [columnDefs, setColumnDefs] = useState([
    { headerName: 'CustomerId', field: 'id', flex: 1 },
    { headerName: 'Contact', field: 'contact', flex: 2 },
    {
      headerName: 'Amount',
      field: 'pendingPaymentAmount',
      flex: 1,
      cellRenderer: (params) => formatAmount(params.value), // Custom cell renderer
    },
    //{ field: 'action', cellRenderer: IconComponent, flex : 1}
  ]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getOldPersonNotPaid(); // Await the async function
      setRowData(Array.isArray(data) ? data : []); // Safeguard if it's not an array
    };

    fetchData(); // Call the async function
  }, []);

  return (
    <div className="ag-theme-alpine mx-auto">
      <h2>ลูกค้าค้างจ่าย</h2>
      <div className='grid grid-cols-6 gap-x-5'>
        <div className='col-span-2' style={{ height: "85vh"}}>
          <AgGridReact
            gridOptions={gridOptions}
            columnDefs={columnDefs}
            rowData={rowData}
            defaultColDef={{ resizable: true }}
          />
        </div>
        <div className='col-span-4'>
          <OrderSummaryTable orders={orders}/>
        </div>
      </div>
    </div>
  );
};

export default CollectMoneyOldNotPaid;
